module.exports = __webpack_public_path__ + "static/k1-5827cf507ae0245a77747776a6e113b7.png";